import { HeadRoles, StaffRoles } from "@cs124/person";
import { Array, Boolean, Literal, Number, Record, String, Union } from "runtypes";
export const ScheduleKinds = Union(Literal("officeHours"), Literal("tutoring"), Literal("discussion"));
export const Slot = Record({
  semester: String,
  kind: ScheduleKinds,
  day: String,
  hour: String,
  start: Number,
  end: Number
});
export const Schedulable = Slot.And(
  Record({
    emails: Array(String),
    java: Number,
    kotlin: Number
  })
);
export const SchedulingStatus = Record({
  open: Boolean,
  disabled: Boolean,
  canSelfSchedule: Array(StaffRoles),
  currentKinds: Array(ScheduleKinds),
  lockoutHours: Number
});
export const emptyStatus = SchedulingStatus.check({
  open: true,
  disabled: false,
  canSelfSchedule: [],
  currentKinds: [],
  lockoutHours: 0
});
export const checkRole = (role, who, netID, mentees, selfSchedule) => {
  if (HeadRoles.includes(role)) {
    return true;
  }
  if (role === "associate" && mentees.includes(who)) {
    return true;
  }
  if (selfSchedule.includes(role) && who === netID) {
    return true;
  }
  return false;
};
export const canUseSchedule = (role, selfSchedule) => ["instructor", "head", "headta", "associate"].includes(role) || selfSchedule.includes(role);
export const canSelfSchedule = (role, selfSchedule) => HeadRoles.includes(role) || selfSchedule.includes(role);
//# sourceMappingURL=schedulable.js.map
